import React, { useState } from 'react'
import ConfirmModal from '../Components/Page/StartQuiz/Actions/ConfirmModal';
import QuizDetails from '../Components/Page/StartQuiz/QuizDetails';
interface props{
  userId:string
}
function Home({userId}:props) {
  //console.log(userId);
  
  return (
    <div>
      <QuizDetails userId={userId}/>
    </div>
  )
}

export default Home